export const calculateStatus = (task) => {
    if (task.actualCompletionDate) return 'Completed';
    
    if (task.deadline) {
      const today = new Date();
      const deadline = new Date(task.deadline);
      const diffDays = Math.floor((today - deadline) / (1000 * 60 * 60 * 24));
  
      if (diffDays > 0) {
        if (diffDays <= 7) return 'On Time';
        if (diffDays <= 30) return 'Slight Delay';
        return 'Significant Delay';
      }
    }
    
    return 'Work in Progress';
  };
  
  export const sortTasks = (a, b) => {
    const dateComparison = new Date(b.createdDate) - new Date(a.createdDate);
    if (dateComparison !== 0) return dateComparison;
    
    const statusPriority = {
      'Significant Delay': 1,
      'Slight Delay': 2,
      'On Time': 3,
      'Work in Progress': 4,
      'Completed': 5
    };
    
    return statusPriority[a.status] - statusPriority[b.status];
  };